import React from 'react'
import { useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const YoungestGamerIcon: React.FC<IIconProps> = (props) => {
  const theme = useTheme()
  return (
    <svg
      version='1.1'
      id='Capa_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      height={props.width}
      width={props.width}
      fill={theme.palette.text.primary}
      viewBox='0 0 478.646 478.646'
    >
      <g>
        <g>
          <path
            d='M239.318,129.859c18.002,0,35.423-7.846,47.369-21.311c12.062-13.593,17.723-32.048,15.43-50.071c-2.248-17.677-12.144-33.861-26.781-44.006c-14.995-10.394-34.183-13.792-51.85-9.244c-17.153,4.415-31.95,16.163-40.21,31.822c-8.522,16.159-9.584,35.729-2.879,52.723c6.488,16.441,19.916,29.702,36.439,35.979C224.002,128.474,231.653,129.859,239.318,129.859z'
          />
          <path
            d='M396.377,3.368c-8.543-5.935-20.276-3.821-26.213,4.721c0,0-58.797,89.646-78.961,113.653c-15.046,17.913-29.379,22.915-50.979,19.929c-10.667-1.475-142.831-34.333-142.831-34.333c-9.274-2.24-19.01,3.081-22.171,12.073c-3.052,8.68,0.821,18.597,8.966,22.89c0.742,0.391,1.511,0.732,2.298,1.022l143.352,52.762c0.816,2.469,7.846,21.487,11.833,41.393c2.538,12.663,3.614,25.566,4.345,38.447c0.515,9.032,0.375,18.069,0.271,27.109c-0.107,9.317,1.421,18.433,5.113,27.023c-0.316,11.767-0.925,23.531-1.925,35.261c-1.095,12.834-3.107,25.591-5.204,38.309c-2.65,16.069-6.804,22.246-7.083,22.665c-5.144,1.946-11.37,1.279-16.696,0.58c-6.363-0.835-12.632-2.338-18.786-4.14c-5.408-1.584-10.743-3.417-16-5.444c-4.18-1.612-8.248-3.452-12.368-5.201c-1.917-0.813-3.822-1.714-5.931-2.171c-2.166-0.47-4.398-0.622-6.608-0.453c-4.376,0.335-8.627,1.935-12.134,4.572c-7.324,5.512-10.712,15.145-8.477,24.025c1.583,6.286,5.82,11.695,11.546,14.734c18.377,10.05,38.03,18.672,58.566,23.128c11.119,2.412,22.655,3.601,33.977,1.973c11.763-1.69,22.945-6.623,31.485-14.993c2.037-1.996,3.917-4.192,5.608-6.491c0,0.007-0.004,0.014-0.012,0.02c-0.021,0.029-0.044,0.061-0.064,0.093c0.928-1.544,2.104-2.964,3.082-4.479c1.666-2.574,3.203-5.23,4.625-7.947c2.847-5.436,5.281-11.085,7.445-16.823c4.344-11.519,7.706-23.4,10.591-35.36c1.895-7.852,3.583-15.753,5.111-23.684c3.197-0.14,6.364-0.512,9.504-1.126c5.679,11.608,10.942,23.428,15.409,35.56c-11.96,4.665-17.812,18.745-12.727,30.529c3.441,7.979,7.622,15.603,13.492,22.085c6.381,7.046,14.46,12.516,23.684,15.054c5.044,1.39,10.34,1.857,15.518,1.06c10.4-1.632,19.107-9.728,20.96-20.681c4.004-23.586,0.181-47.695-5.239-70.752c-2.937-12.491-6.513-24.835-10.503-37.028c-2.612-7.984-5.317-15.978-8.453-23.775c-0.622-1.547-1.216-3.106-1.878-4.638c0.774-5.185,0.839-10.385,0.409-15.602c-0.43-5.215-0.787-10.444-1.325-15.649c-1.272-12.316-2.989-24.617-5.307-36.781c-4.83-25.334-11.619-50.367-21.603-74.186c-2.712-6.47-5.625-12.848-8.872-19.067l67.023-125.525C406.696,19.392,404.308,8.879,396.377,3.368C387.834-2.567,404.308,8.879,396.377,3.368z'
          />
        </g>
      </g>
    </svg>
  )
}

export default YoungestGamerIcon
